module.exports = __webpack_public_path__ + "img/nasket-logo.458737ff.png";